import { render } from "./VideoDetail.vue?vue&type=template&id=8d250026&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=ts"
export * from "./VideoDetail.vue?vue&type=script&lang=ts"

import "./VideoDetail.vue?vue&type=style&index=0&id=8d250026&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8d250026"

export default script